<div class="chat-suggestions" [class.chat-suggestions--grid]="layout === layouts.Grid">
  <div
    class="chat-suggestions__list"
    [class.chat-suggestions__list--grid]="layout === layouts.Grid"
    *ngIf="loading; else topicList"
  >
    <div class="chat-suggestions__item chat-suggestions__item--skeleton" *ngFor="let item of skeletonItems; trackBy: trackBySkeleton">
      <div class="chat-suggestions__icon chat-suggestions__icon--skeleton"></div>
      <div class="chat-suggestions__text">
        <span class="chat-suggestions__title chat-suggestions__title--skeleton"></span>
      </div>
    </div>
  </div>

  <ng-template #topicList>
    <div
      class="chat-suggestions__list"
      [class.chat-suggestions__list--grid]="layout === layouts.Grid"
    >
      <button
        *ngFor="let topic of topics; trackBy: trackByTopic"
        type="button"
        class="chat-suggestions__item"
        (click)="onSelect(topic)"
      >
        <div class="chat-suggestions__icon">
          <i [class]="topic.icon"></i>
        </div>
        <div class="chat-suggestions__text">
          <span class="chat-suggestions__title">{{ topic.message }}</span>
        </div>
        <span class="chat-suggestions__badge" *ngIf="isQuickAction(topic)">
          <i class="fas fa-bolt"></i>
          Ação
        </span>
        <i class="fas fa-chevron-right chat-suggestions__chevron"></i>
      </button>
    </div>
  </ng-template>
</div>
